import { render, staticRenderFns } from "./UsersSetting.vue?vue&type=template&id=63537e4d&scoped=true&"
import script from "./UsersSetting.vue?vue&type=script&lang=js&"
export * from "./UsersSetting.vue?vue&type=script&lang=js&"
import style0 from "./UsersSetting.vue?vue&type=style&index=0&id=63537e4d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63537e4d",
  null
  
)

export default component.exports